import React from 'react'
import ReactDOM from 'react-dom'
import 'mapbox-gl/dist/mapbox-gl.css'
import './styles/main.scss'
import App from './App'

ReactDOM.render(
  <App />,
  document.getElementById('root')
)